// @flow
import * as React from 'react';
import styled from 'styled-components';
import { Button } from 'primitive-components';
import { colors } from 'bench-style-constants';

const BannerContainer = styled.div`
  align-items: center;
  background: ${colors.shell};
  display: flex;
  justify-content: space-between;
  padding: 24px;
`;

const CloseButton = styled(Button)`
  border-radius: 50%;
  padding: 0;

  svg {
    fill: ${colors.dust};
    height: 24px;
    transition: fill 0.2s ease-out;
    width: 24px;
    margin-left: 16px;

    &:hover {
      fill: ${colors.clay};
    }
  }
`;

type BannerProps = {
  children: React.Node,
  localStorageKey: string,
};

export type BannerState = {
  isBannerVisible: boolean,
};

export default class Banner extends React.Component<BannerProps, BannerState> {
  constructor(props: BannerProps) {
    super(props);
    this.state = {
      isBannerVisible: !window.localStorage.getItem(props.localStorageKey),
    };
  }

  handleHideBanner() {
    window.localStorage.setItem(this.props.localStorageKey, false);
    this.setState({ isBannerVisible: false });
  }

  render() {
    const { isBannerVisible } = this.state;

    return (
      isBannerVisible && (
        <BannerContainer>
          {this.props.children}
          <CloseButton size="small" iconLeft="cancel" onClick={() => this.handleHideBanner()} />
        </BannerContainer>
      )
    );
  }
}
